module.exports = __webpack_public_path__ + "img/inverti.66a84510.svg";